import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SegurancaService } from '../service/seguranca/seguranca.service';
import { PoliticaSenha } from '../model/politica-senha';


@Injectable()
export class PoliticaSenhaResolve implements Resolve<PoliticaSenha> {

    constructor(
        private segurancaService : SegurancaService
    ) {}

    resolve() : Observable<PoliticaSenha> {
        return this.segurancaService.obterPoliticaSenha();
    }
}